import React from "react";
import FadeIn from "react-fade-in";

export const PageTransition = ({
  children,
  alias,
  delay,
  transitionDuration,
  element,
}) => {
  return (
    <FadeIn
      className="transition_list"
      delay={delay}
      transitionDuration={transitionDuration}
    >
      {children}
    </FadeIn>
  );
};
